import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { Select } from './Select';

// Repo Audit tab toolbar (#349): the trigger + outcome grammar filters. A change
// resets the list to page one — the container owns that reset via the callbacks.
//
// Each filter is a standalone `label[for]` over the themed Select's trigger, not a
// wrapping label: the trigger is a button, and the open listbox names itself by the
// label's own `${id}-label`, so both ids below are load-bearing.
const TRIGGERS = ['', 'issue', 'pr', 'release', 'manual'] as const;
const OUTCOMES = ['', 'completed', 'escalated', 'failed', 'handed_back'] as const;

export function RepoAuditFilters(props: {
  trigger: string;
  outcome: string;
  onTrigger: (v: string) => void;
  onOutcome: (v: string) => void;
}): JSX.Element {
  return (
    <div class="filter-row">
      <div class="repo-audit__field">
        <label
          class="repo-audit__field-label"
          for="repo-audit-trigger"
          id="repo-audit-trigger-label"
        >
          {t('repo_detail.audit_filter_trigger')}
        </label>
        <Select
          a11y={{ id: 'repo-audit-trigger' }}
          label={t('repo_detail.audit_filter_trigger')}
          value={props.trigger}
          options={TRIGGERS.map((v) => ({
            value: v,
            label: t(`repo_detail.audit_trigger_${v || 'all'}`),
          }))}
          onChange={props.onTrigger}
        />
      </div>
      <div class="repo-audit__field">
        <label
          class="repo-audit__field-label"
          for="repo-audit-outcome"
          id="repo-audit-outcome-label"
        >
          {t('repo_detail.audit_filter_outcome')}
        </label>
        <Select
          a11y={{ id: 'repo-audit-outcome' }}
          label={t('repo_detail.audit_filter_outcome')}
          value={props.outcome}
          options={OUTCOMES.map((v) => ({
            value: v,
            label: t(`repo_detail.audit_outcome_${v || 'all'}`),
          }))}
          onChange={props.onOutcome}
        />
      </div>
    </div>
  );
}
